import {z} from '@hono/zod-openapi';

import {priceReportArgumentSetSchema} from './PriceReportArgumentSetSchema';

/** Structured output the model returns: both sides of the deal in one call. */
export const priceReportArgumentsModelOutputSchema = z
  .object({
    selling: priceReportArgumentSetSchema,
    buying: priceReportArgumentSetSchema,
  })
  .openapi('PriceReportArgumentsModelOutput');

export type PriceReportArgumentsModelOutput = z.infer<typeof priceReportArgumentsModelOutputSchema>;
